import Reflux from 'reflux';

const WebinarActions = Reflux.createActions([
  'initWebinar',
  'initComplete',
]);

export default WebinarActions;
